import { classNames } from '@progress/kendo-react-common';
import { Step, StepProps} from '@progress/kendo-react-layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import styles from './DisputeStep.module.scss';
import { DisputeStatus } from 'enums';

export type DisputeStepProps = {
    done: boolean,
    id: DisputeStatus,
    status: DisputeStatus,
    label: string,
    faIcon: IconProp,
} & StepProps | StepProps;

export const DisputeStep = (props: DisputeStepProps) => {
    const { current, done, faIcon, id, index, label } = props;
    
    return (
        <Step current={current} index={index} className={classNames(styles.step, {
            [styles.current]: current,
            [styles.done]: done,
            [styles.finalReview] : current && id === DisputeStatus.FinalReview,
            [styles.vendorReview] : current && id === DisputeStatus.VendorReview,
        })}>
            <div className={styles.outerCircle}>
                <div className={styles.innerCircle}>
                    <FontAwesomeIcon className={styles.icon} icon={faIcon} />
                </div>
            </div>
            <span className={styles.label}>{label}</span>
        </Step>
    );
};